import { BookRidePriorityType, BookRideStops, GeocodeAddress, StopData } from '../ride-planner.model';
import { RidePlannerPartialStoreState, RIDE_PLANNER_STATE_KEY } from './ride-planner.reducer';

export const getStep = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].step;

export const getBookingStatus = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].bookingStatus;

export const getBookingId = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].bookingId;

export const getPlan = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].plan;

export const getSpecification = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].specification;

export const getDateAndTime = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].plan.dateAndTime;

export const getEstimatedPrice = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].estimatedPrice;

export const getProducts = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].products;

export const getIsInvoice = (state: RidePlannerPartialStoreState) =>
    state[RIDE_PLANNER_STATE_KEY].specification.isInvoice;

export const getPriorityTime = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].plan.priority;

export const getPassenger = (state: RidePlannerPartialStoreState) =>
    state[RIDE_PLANNER_STATE_KEY].specification.companion;

export const getProductId = (state: RidePlannerPartialStoreState) =>
    state[RIDE_PLANNER_STATE_KEY].specification.productId;

export const getAdditionalInformation = (state: RidePlannerPartialStoreState) =>
    state[RIDE_PLANNER_STATE_KEY].specification.additionalInformation;

export const getStops = (state: RidePlannerPartialStoreState) => {
    const plan = state[RIDE_PLANNER_STATE_KEY].plan;
    const stopovers = state[RIDE_PLANNER_STATE_KEY].plan.stopovers;
    const priority = state[RIDE_PLANNER_STATE_KEY].plan.priority;
    const time = state[RIDE_PLANNER_STATE_KEY].plan.dateAndTime;

    const pickup = plan.pickupFeature;
    const dropoff = plan.dropoffFeature;
    const stops: any = [];

    stops.push(newStop(pickup, priority === BookRidePriorityType.PICKUP ? time : null));
    if (stopovers && stopovers.length > 0) {
        stopovers.forEach((stopover) => stops.push(newStop(stopover)));
    }
    stops.push(newStop(dropoff, priority === BookRidePriorityType.DROPOFF ? time : null));

    function newStop(feature: GeocodeAddress, arrivalTime = null) {
        const stop: BookRideStops = {
            address: feature.address,
            latitude: feature.lat,
            longitude: feature.lon,
        };

        if (arrivalTime !== null) {
            stop.arrival_time = new Date(arrivalTime).toISOString();
        }

        return stop;
    }

    return stops;
};

export const getError = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].error;
export const getLoading = (state: RidePlannerPartialStoreState) => state[RIDE_PLANNER_STATE_KEY].loading;

export const getIsReturnWithPlan = (state: RidePlannerPartialStoreState) => ({
    isReturn: state[RIDE_PLANNER_STATE_KEY].isReturn,
    plan: state[RIDE_PLANNER_STATE_KEY].plan,
});

export const getPotentialStops = (state: RidePlannerPartialStoreState) => {
    return state[RIDE_PLANNER_STATE_KEY].potentialStops.map((stopData: StopData) => {
        return {
            address: stopData.stop_name,
            direction: stopData.direction,
            lat: stopData.latitude,
            lon: stopData.longitude,
            latlng: {
                lat: stopData.latitude,
                lng: stopData.longitude,
            }
        }
    });
};

export const getFilteredStops = (state: RidePlannerPartialStoreState) => {
    return state[RIDE_PLANNER_STATE_KEY].filteredStops.map((stopData: StopData) => {
        return {
            address: stopData.stop_name,
            direction: stopData.direction,
            lat: stopData.latitude,
            lon: stopData.longitude,
            latlng: {
                lat: stopData.latitude,
                lng: stopData.longitude,
            }
        }
    });
};
